import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { zIndex } from '@ecp/common/src/style/constant';
import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import FloatingUnstyled from '@ecp/common/src/components/unstyled/floating/FloatingUnstyled';
import { placements } from '@ecp/common/src/components/unstyled/floating/useCustomFloating';

const Floating = ({ children, value, ...props }) => {
  return (
    <FloatingUnstyled rootComponent={StyledFloatingWrapper} value={value} {...props}>
      {children}
    </FloatingUnstyled>
  );
};

Floating.displayName = 'Floating';

Floating.propTypes = {
  children: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  placement: PropTypes.oneOf(placements),
};

export default Floating;

export const StyledFloatingWrapper = styled(FlexBoxColumn)`
  background-color: ${boTheme.color.sub10};
  width: max-content;
  border-width: 1px;
  border-style: solid;
  border-color: ${boTheme.color.sub6};
  z-index: ${zIndex.floating};
  border-radius: 3px;
  box-sizing: border-box;

  &:focus-visible {
    outline: none;
  }
`;
